import { render, staticRenderFns } from "./viewFileModel.vue?vue&type=template&id=6b859858&scoped=true"
import script from "./viewFileModel.vue?vue&type=script&lang=js"
export * from "./viewFileModel.vue?vue&type=script&lang=js"
import style0 from "./viewFileModel.vue?vue&type=style&index=0&id=6b859858&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b859858",
  null
  
)

export default component.exports